<template>
    <div>
        <div class="modal fade" id="mdo_que_ha_denovo">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" style="margin-right: 5px; position: relative;">
                <div class="modal-content">
                    <div class="modal-header" style="padding-left: 21px;">
                        <div class="row" style="width: 100%;">
                            <h4  class="modal-title">O que há de novo!</h4>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row" style="margin-bottom: 10px;">
                            <div v-if="lstatzs.length > 0" class="col-12">
                                <div v-for="(atz, indice) in lstatzs" class="card" style="margin-bottom: 40px;">
                                    <div class="card-body">
                                        <div class="col-12">
                                            <h5> {{ atz.descricao }}</h5>
                                        </div>
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div :id="'carouselExampleControls'+indice" class="carousel slide" data-ride="carousel">
                                                        <div class="carousel-inner">
                                                            <template v-for="(imagem, index) in atz.arquivos">
                                                                <div v-if="index===0" class="carousel-item active">
                                                                    <img class="d-block w-100 imgcars" :src="'https://rillsoft.app/sacweb/controller/'+imagem.linkarquivo"  alt="First slide">
                                                                </div>
                                                                <div v-else class="carousel-item">
                                                                    <img class="d-block w-100 imgcars":src="'https://rillsoft.app/sacweb/controller/'+imagem.linkarquivo" alt="First slide">
                                                                </div>
                                                            </template>
                                                         
                                                        </div>
                                                        <a class="carousel-control-prev" :href="'#carouselExampleControls'+indice" role="button" data-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="sr-only">Anterior</span>
                                                        </a>
                                                        <a class="carousel-control-next" :href="'#carouselExampleControls'+indice" role="button" data-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="sr-only">Proximo</span>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="col-12"  v-html="atz.corpo">
                                                    
                                               </div>
                                            </div>
                                        </div>
                                         
                                    </div>
                                    <div class="card-footer" style="padding-bottom: 20px;">
                                        <div class="row">
                                            <div class="col-8"> <textarea class="form-control center" placeholder="Digite seu comentário" rows="2" v-model="atz.comentario"></textarea></div>
                                            <div class="col-2">
                                                <div class="text-right" style="align-items: right;">
                                                    <button v-if="parseInt(atz.like)==0" type="button" class="btn  btn-sm bgnone" @click.prevent="mtdlike(indice, 1)"><i class="fa fa-thumbs-up"></i></button>
                                                    <button v-else-if="parseInt(atz.like)==1" type="button" class="btn  btn-sm btn-green" @click.prevent="mtdlike(indice, 1)"><i class="fa fa-thumbs-up"></i></button>
                                                    <span style="margin-right: 10px;"></span> 
                                                    <button v-if="parseInt(atz.deslike)==0" type="button" class="btn btn-sm  btn-sm bgnone"  @click.prevent="mtdlike(indice, 2)" ><i class="fa fa-thumbs-down"></i></button>
                                                    <button v-else-if="parseInt(atz.deslike)==1" type="button" class="btn  btn-sm btn-red"  @click.prevent="mtdlike(indice, 2)" ><i class="fa fa-thumbs-down"></i></button>
                                                </div>
                                            </div>
                                            <div class="col-2">
                                                <button  type="button" class="btn btn-success btn-sm" @click.prevent="mtdenviar(indice)">Enviar</button>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px; border-radius: 15px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
import util from '../utilitarios/util.js';
export default {
    name : "cmpwhatsnew",
    components: {
    },

    data () {
        return {
            lstatzs: [],

        }
    },
    methods:{  
      mtdenviar(indice){


        let feedback = null

        if((parseInt(this.lstatzs[indice].like)===0)&&(parseInt(this.lstatzs[indice].deslike)===0)){
            this.$toastr.w('Informe o seu Feedback!', 'Informação!');
            return
        }
        if(this.lstatzs[indice].comentario ===''){
            this.$toastr.w('Informe o seu comentário!', 'Informação!');
            return
        }


        if(parseInt(this.lstatzs[indice].like)===1){
            feedback = 1
        }

        if(parseInt(this.lstatzs[indice].deslike)===1){
            feedback = 0
        }

        let comentario  = this.lstatzs[indice].comentario
        let id          = this.lstatzs[indice].id

        var vself       = this;
        let loader      = this.$loading.show();
        let parametros  = [
            {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
            {parametro: 'param1',       valor : 'enviarfeedback'},
            {parametro: 'idatz',        valor : id },
            {parametro: 'feedback',     valor : feedback },
            {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
            {parametro: 'nomeusuario',  valor : vself.$store.state.usuario.nome},
            {parametro: 'comentario',   valor : comentario},
            
        ];
        let retorno           = util.reqaxios(parametros, 'post', 'rillsoft.app/sacweb/controller/rotinanewsatz.php');
        retorno.then(function (response) {
            
            if($.isNumeric(response.data)){
                vself.$toastr.s('Obrigado pelo feedback!', 'Informação!');
                vself.lstatzs;
                vself.listaratzs();
            }else{
                vself.$toastr.e('Ocorreu um erro inesperado: '+response.data, 'Informação!');
            }
            loader.hide();
        }).catch(function (response) {
            loader.hide();
        });



      },   
      mtdlike(indice, op){
        if(op==1){
            if(parseInt(this.lstatzs[indice].like)===0){
                this.lstatzs[indice].like = 1
                this.lstatzs[indice].deslike = 0
            }else{
                this.lstatzs[indice].like = 0
                this.lstatzs[indice].deslike = 0
            }
        }else{
            if(parseInt(this.lstatzs[indice].deslike)===0){
                this.lstatzs[indice].deslike = 1
                this.lstatzs[indice].like = 0
            }else{
                this.lstatzs[indice].deslike = 0
                this.lstatzs[indice].like = 0
            } 
        }

      },  
      sortedArquivos() {
        this.lstatzs.forEach((atz) => {
            atz.arquivos.sort((a, b) => {
                // Substitua 'nomearquivo' pelo campo que contém o nome do arquivo nas imagens
                const nomeArquivoA = a.linkarquivo.split('/').pop();
                const nomeArquivoB = b.linkarquivo.split('/').pop();
                return nomeArquivoA.localeCompare(nomeArquivoB);
            });
        });
      }, 
      listaratzs(){
            var vself       = this;
            let loader      = this.$loading.show();
            let parametros  = [
                {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                {parametro: 'param1',       valor : 'listaratz'},
               
            ];
            let retorno           = util.reqaxios(parametros, 'post', 'rillsoft.app/sacweb/controller/rotinanewsatz.php');
            retorno.then(function (response) {
                vself.lstatzs = response.data;
                vself.sortedArquivos()
                loader.hide();
            }).catch(function (response) {
                vself.lstatzs = [];
                loader.hide();
            });
      },
    },
    mounted: function () {      
         let vself = this;

        $('#mdo_que_ha_denovo').on('show.bs.modal', function (e) {
			vself.listaratzs();
		});	
        
    },    
    computed:{

          
    },
    watch:{
        lstatzs(){
            if(this.lstatzs.length === 0){
                $('#mdo_que_ha_denovo').modal('hide');
            }
        }
    }    
}
</script>
<style scoped>
   .imgcars{
    width: 300px;
    height: 300px;
    border-radius: 30px;
    /* object-fit: cover;  */
   }
   .bgnone{
     background-color: grey;
   }
   .bglike{
     background-color: rgb(67, 255, 127);
   }
   .bgdeslike{
     background-color: rgb(250, 116, 116);
   }
</style>